var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAv3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1587_43582",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 106,
    height: 106
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 53,
    fill: "#EAEAEA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1587_43582)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1587_43582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.2554 106.511C82.6676 106.511 106.511 82.6676 106.511 53.2554C106.511 23.8433 82.6676 0 53.2554 0C23.8433 0 0 23.8433 0 53.2554C0 82.6676 23.8433 106.511 53.2554 106.511Z",
    fill: "#FFD3B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3611 118.776H28.5364V113.956C28.5364 101.046 36.5236 91.6641 47.5276 91.6641V97.4888C39.7813 97.4888 34.3611 104.26 34.3611 113.956V118.776Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2854 118.776H71.4606V113.956C71.4606 104.26 66.0469 97.4888 58.2942 97.4888V91.6641C69.2982 91.6641 77.2854 101.039 77.2854 113.956V118.776Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1215 96.3263V116.871H41.8167V96.3263C41.8167 93.7442 45.565 91.6592 48.1428 91.6592H57.8019C60.3797 91.6635 64.1215 93.7485 64.1215 96.3263Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9711 98.7478C52.9711 98.7478 46.9075 96.0345 46.9075 92.6864V80.9336H59.0325V92.6864C59.0346 96.0345 52.9711 98.7478 52.9711 98.7478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9709 74.551C44.2736 74.551 36.3401 72.2939 30.6337 68.1948C24.2926 63.6396 20.9402 57.1801 20.9402 49.5156V36.7279C20.9402 21.0202 35.0104 8.72949 52.9709 8.72949C70.9314 8.72949 84.993 21.0288 84.993 36.7279V49.5156C84.993 57.1801 81.6428 63.6396 75.3102 68.1948C69.6017 72.2982 61.6682 74.551 52.9709 74.551Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4282 58.0272C30.9607 54.7174 28.7092 51.6026 25.3994 51.0701C22.0896 50.5375 18.9748 52.789 18.4422 56.0988C17.9097 59.4087 20.1612 62.5235 23.471 63.056C26.7808 63.5885 29.8957 61.3371 30.4282 58.0272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3756 59.3816C88.6585 56.2844 87.1877 52.7336 84.0905 51.4507C80.9933 50.1678 77.4425 51.6386 76.1596 54.7358C74.8767 57.833 76.3474 61.3837 79.4447 62.6667C82.5419 63.9496 86.0926 62.4788 87.3756 59.3816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9714 86.8542C37.2766 86.8542 24.4351 78.1397 24.4351 62.445V48.1983C24.4351 32.5036 37.2766 20.4883 52.9714 20.4883C68.6661 20.4797 81.5098 32.4907 81.5098 48.1983V62.4536C81.5098 78.1397 68.6661 86.8542 52.9714 86.8542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9708 72.8747C47.7743 72.8747 42.7737 71.1791 38.8877 68.0978C37.98 67.3768 37.396 66.3247 37.264 65.173C37.1321 64.0214 37.463 62.8644 38.1841 61.9568C38.9051 61.0491 39.9572 60.4651 41.1089 60.3331C42.2605 60.2012 43.4175 60.5321 44.3251 61.2532C46.6727 63.1144 49.7475 64.1386 52.9815 64.1386C56.1661 64.1386 59.2065 63.1402 61.5411 61.3285C62.4565 60.6183 63.6165 60.3008 64.766 60.4458C65.9154 60.5909 66.9601 61.1867 67.6704 62.102C68.3806 63.0174 68.698 64.1774 68.553 65.3268C68.4079 66.4763 67.8122 67.521 66.8968 68.2312C63.0258 71.2221 58.0962 72.8747 52.9708 72.8747Z",
    fill: "#FFD3B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8184 50.3982C40.8184 49.2075 39.8531 48.2422 38.6624 48.2422C37.4716 48.2422 36.5063 49.2075 36.5063 50.3982V52.1411C36.5063 53.3319 37.4716 54.2972 38.6624 54.2972C39.8531 54.2972 40.8184 53.3319 40.8184 52.1411V50.3982Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2889 54.2964C66.7191 54.2935 66.1735 54.0659 65.7706 53.663C65.3676 53.2601 65.14 52.7144 65.1372 52.1446V50.4017C65.14 49.8319 65.3676 49.2863 65.7706 48.8834C66.1735 48.4804 66.7191 48.2528 67.2889 48.25C67.8587 48.2528 68.4044 48.4804 68.8073 48.8834C69.2102 49.2863 69.4378 49.8319 69.4407 50.4017V52.1446C69.4378 52.7144 69.2102 53.2601 68.8073 53.663C68.4044 54.0659 67.8587 54.2935 67.2889 54.2964Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7273 45.8165C85.0999 45.8951 84.4682 45.9346 83.8359 45.9349H51.8331C49.8204 45.9349 47.8274 45.5384 45.9678 44.7682C44.1083 43.9979 42.4187 42.869 40.9955 41.4457C39.5722 40.0225 38.4433 38.3329 37.673 36.4734C36.9028 34.6138 36.5063 32.6208 36.5063 30.6081C36.5063 28.5953 36.9028 26.6023 37.673 24.7427C38.4433 22.8832 39.5722 21.1936 40.9955 19.7704C42.4187 18.3471 44.1083 17.2182 45.9678 16.4479C47.8274 15.6777 49.8204 15.2812 51.8331 15.2813H72.2294C80.2253 22.1926 85.4755 33.1148 85.7273 45.8165Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2683 27.5637H79.543C81.1703 27.5592 82.7296 26.9107 83.8803 25.7601C85.031 24.6094 85.6795 23.05 85.684 21.4227C85.6806 19.7946 85.0327 18.2342 83.8818 17.0826C82.731 15.9309 81.171 15.2819 79.543 15.2773H61.2683C59.6417 15.2825 58.0832 15.9309 56.9331 17.081C55.7829 18.2312 55.1345 19.7897 55.1294 21.4162C55.1322 23.0443 55.7796 24.605 56.9301 25.757C58.0805 26.909 59.6402 27.5586 61.2683 27.5637Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.738 27.5635H58.4368C53.3648 27.5635 49.2532 31.6751 49.2532 36.7471V36.7492C49.2532 41.8212 53.3648 45.9328 58.4368 45.9328H85.738C90.8099 45.9328 94.9216 41.8212 94.9216 36.7492V36.7471C94.9216 31.6751 90.8099 27.5635 85.738 27.5635Z",
    fill: "#0A0A0A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1587_43582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 106,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAv3);
export default __webpack_public_path__ + "static/media/Av3.0128e9a9809dfdade41df0e85aef91cc.svg";
export { ForwardRef as ReactComponent };